
import { defineComponent, computed, watch } from 'vue'
  import { ElMessage } from 'element-plus'
import { useRoute } from 'vue-router'
import { useStore } from './store/index'
  export default defineComponent({
    name: 'App',
    setup() {
      const store = useStore()
      const route = useRoute()
      const isLoading = computed(() => store.getters.isLoading)
      const showLoading = computed(() => isLoading.value && !route.meta.disableLoading)
      const error = computed(() => store.state.global.error)
      watch(() => error.value.status, (errorValue) => {
        if (errorValue) {
          ElMessage({
            type: 'error',
            message: error.value.message || '未知错误'
          })
        }
      })
      return {
        showLoading
      }
    }
  })
